import { render, staticRenderFns } from "./CTAType3.vue?vue&type=template&id=42bc0182&scoped=true"
import script from "./CTAType3.vue?vue&type=script&lang=js"
export * from "./CTAType3.vue?vue&type=script&lang=js"
import style0 from "./CTAType3.vue?vue&type=style&index=0&id=42bc0182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc0182",
  null
  
)

export default component.exports